// extracted by mini-css-extract-plugin
export default {"preview_container":"PreviewSection_preview_container__+n6yF","mobile_preview_container":"PreviewSection_mobile_preview_container__jzw4u"};